import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { Header } from 'foundations-components/transitional/components/Header';
import { Tabs as FoundationsTabs, Tab } from 'foundations-components/transitional/components/Tabs';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import ListingLibTitleWithCounts from 'framework-listing-lib/elements/ListingLibTitleWithCounts';
import NonHubSpotStatus from 'FormsUI/components/dashboard/nonHubSpotStatus/NonHubSpotStatusContainerLoadable';
import FormCreationButton from 'FormsUI/components/dashboard/FormCreationButtonContainer';
import DashboardActions from 'FormsUI/components/dashboard/DashboardActions';
import { TABS } from 'FormsUI/constants/Dashboard';
import { useFormCreation } from 'FormsUI/hooks/useFormCreation';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Tabs = ({
  selected,
  onChange
}) => /*#__PURE__*/_jsxs(TFlex, {
  align: "center",
  children: [/*#__PURE__*/_jsxs(FoundationsTabs, {
    selected: selected,
    onSelectedChange: ({
      target: {
        value
      }
    }) => {
      if (value === TABS.MANAGE || value === TABS.ANALYZE) {
        onChange(value);
      }
    },
    children: [/*#__PURE__*/_jsx(Tab, {
      tabId: TABS.MANAGE,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'dashboard.tabs.manage'
      })
    }), /*#__PURE__*/_jsx(Tab, {
      tabId: TABS.ANALYZE,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'dashboard.tabs.analyze'
      })
    })]
  }), /*#__PURE__*/_jsx(View, {
    as: "span",
    marginInlineStart: "auto",
    children: /*#__PURE__*/_jsx(TFlex, {
      children: /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(NonHubSpotStatus, {})
      })
    })
  })]
});
const FormsDashboardHeader = ({
  tab,
  onTabChange,
  isComparisonAllowed,
  isPortalZeroState
}) => {
  const {
    onCreateFormClick
  } = useFormCreation({
    isPortalZeroState
  });
  const onClick = useCallback(() => {
    trackDashboardInteraction('create-form-button-click');
    return onCreateFormClick();
  }, [onCreateFormClick]);
  const isManageTab = tab === TABS.MANAGE;
  const shouldShowDashboardActions = !isPortalZeroState && !isManageTab;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Header, {
      marginBlockEnd: "0",
      title: isManageTab ? /*#__PURE__*/_jsx(ListingLibTitleWithCounts, {
        title: /*#__PURE__*/_jsx(TFlex, {
          align: "center",
          gap: 4,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'dashboard.formsHeading'
          })
        })
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'dashboard.formsHeading'
      }),
      flush: true,
      tabs: /*#__PURE__*/_jsx(Tabs, {
        selected: tab,
        onChange: onTabChange
      }),
      children: [shouldShowDashboardActions ? /*#__PURE__*/_jsx(DashboardActions, {
        isPqlDisabled: !isComparisonAllowed
      }) : null, /*#__PURE__*/_jsx(FormCreationButton, {
        isPortalZeroState: isPortalZeroState,
        onClick: onClick
      })]
    })
  });
};
export default FormsDashboardHeader;